import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "@/lib/content";
import { Reveal, SectionLabel } from "@/components/landing/Reveal";

export const OnlineTestimonials = () => (
  <section className="relative px-4 py-16 sm:px-8 lg:py-24" data-testid="online-testimonials-section">
    <div className="mx-auto max-w-6xl">
      <Reveal className="max-w-2xl">
        <SectionLabel>Student Voices</SectionLabel>
        <h2 className="mt-4 font-display text-5xl font-bold uppercase leading-none tracking-tight text-offwhite sm:text-6xl">
          What Our Students Say
        </h2>
      </Reveal>
    </div>

    <div className="mx-auto mt-10 max-w-6xl">
      <div className="flex snap-x snap-mandatory gap-4 overflow-x-auto px-1 pb-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden md:grid md:grid-cols-2 md:overflow-visible lg:grid-cols-4">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.08} className="w-[82%] shrink-0 snap-center md:w-auto">
            <figure className="card-surface flex h-full flex-col rounded-2xl p-6">
              <Quote size={26} className="text-gold/60" />
              <div className="mb-3 mt-3 flex text-gold">
                {[...Array(5)].map((_, k) => (
                  <Star key={k} size={14} fill="currentColor" />
                ))}
              </div>
              <blockquote className="flex-1 text-sm leading-relaxed text-offwhite/90">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-5 border-t border-surfaceline pt-4">
                <p className="font-heading text-lg font-bold text-offwhite">{t.name}</p>
                <p className="text-xs uppercase tracking-wider text-em2">
                  BullsEdge Student, Ahmedabad
                </p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
      <p className="mt-1 px-1 text-center text-xs text-mutedgreen md:hidden">
        ← Swipe to read more →
      </p>
    </div>
  </section>
);
